import React from "react";
import { Button } from "@/components/ui/button";
import { Check, Share2, RefreshCw, Phone } from "lucide-react";

/**
 * Header section with order ID and action buttons
 */
export function TrackingHeader({ 
  deliveryId, 
  copied, 
  onShare, 
  onRefresh 
}) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div>
        <p className="text-sm text-muted-foreground">Order ID</p>
        <p className="font-mono font-bold">{deliveryId}</p>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={onShare} className="rounded-none gap-2" data-testid="share-tracking-btn">
          {copied ? <><Check className="w-4 h-4 text-green-500" />Copied!</> : <><Share2 className="w-4 h-4" />Share</>}
        </Button>
        <Button variant="outline" size="sm" onClick={onRefresh} className="rounded-none gap-2" data-testid="refresh-tracking-btn">
          <RefreshCw className="w-4 h-4" />Refresh
        </Button>
      </div>
    </div>
  );
}

/**
 * Route summary showing pickup and drop locations
 */
export function RouteSummary({ tracking }) {
  return (
    <div className="border border-border p-4 mb-6">
      <div className="flex items-start gap-3">
        <div className="flex flex-col items-center">
          <div className="w-3 h-3 rounded-full bg-green-500" />
          <div className="w-0.5 h-8 bg-border" />
          <div className="w-3 h-3 rounded-full bg-red-500" />
        </div>
        <div className="flex-1 space-y-4">
          <div>
            <p className="font-medium text-sm">{tracking?.pickup_address || "Pickup"}</p>
            {tracking?.sender_phone && (
              <p className="text-xs text-muted-foreground flex items-center gap-1 mt-1">
                <Phone className="w-3 h-3" />{tracking.sender_phone}
              </p>
            )}
          </div>
          <p className="font-medium text-sm">{tracking?.drop_address || "Drop"}</p>
        </div>
      </div>
    </div>
  );
}

/**
 * Delivered banner shown when delivery is complete
 */
export function DeliveredBanner() {
  return (
    <div className="border-2 border-green-500 bg-green-50 dark:bg-green-950 p-6 mb-6">
      <div className="flex items-center gap-4">
        <div className="w-14 h-14 bg-green-500 rounded-full flex items-center justify-center">
          <Check className="w-7 h-7 text-white" />
        </div>
        <div>
          <p className="text-xl font-black text-green-700 dark:text-green-300">Delivered!</p>
          <p className="text-sm text-green-600 dark:text-green-400">Your package has been delivered successfully</p>
        </div>
      </div>
    </div>
  );
}
